export const BREADCRUMB_BOX_PORTAL_ID = 'breadcrumb-box';
export const BREADCRUMB_BOX_PORTAL_EVENT = 'breadcrumbboxready';
